export enum RulerLengthType {
    Inch,
    Centimeter,
    Feet
}
